import React from 'react';
import { motion } from 'framer-motion';
import { staggerContainer, itemVariants } from '../utils/animations';
const stats = [{
  value: '+50',
  label: 'Webs entregadas'
}, {
  value: '72hs',
  label: 'Tiempo promedio'
}, {
  value: '+300%',
  label: 'Presencia online'
}, {
  value: 'LATAM',
  label: 'Clientes activos'
}];
export function SocialProof() {
  return <section className="py-16 md:py-24 relative overflow-hidden" data-id="element-336">
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-electric/5 to-transparent" data-id="element-337"></div>

      <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10" data-id="element-338">
        <motion.div variants={staggerContainer} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12" data-id="element-339">
          {stats.map((stat, idx) => <motion.div key={idx} variants={itemVariants} className="text-center" data-id="element-340">
              <div className="text-4xl md:text-6xl font-bold tracking-tighter text-white mb-2 drop-shadow-[0_0_15px_rgba(255,255,255,0.1)]" data-id="element-341">
                {stat.value}
              </div>
              <div className="text-sm md:text-base font-medium text-neutral-400 uppercase tracking-widest" data-id="element-342">
                {stat.label}
              </div>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}